import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import useMe from "../../common/hooks/useMe";

import DesktopMenu from "./Desktop";
import MobileMenu from "./Mobile";
import PrintDialog from "./PrintDialog";

const MainMenu = ({ mobile = false }) => {
  const [printOpen, setPrintOpen] = useState(false);
  const { me = {} } = useMe();
  const { logout, user, loading: userIsLoading } = useAuth0();
  const history = useHistory();

  const props = { history, setPrintOpen, me, logout, user, userIsLoading };

  return (
    <>
      {mobile && <MobileMenu {...props} />}
      {!mobile && <DesktopMenu {...props} />}
      <PrintDialog open={printOpen} onClose={() => setPrintOpen(false)} />
    </>
  );
};

export default MainMenu;
